import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import styles from "./prose.module.scss";

const cx = classNames.bind(styles);

const Prose = ({ children, className, isSmall, align }) => {
  return (
    <div className={cx("prose", className, isSmall && "small", align)}>
      {children}
    </div>
  );
};

Prose.PropTypes = {
  align: PropTypes.oneOf(["left", "center", "right"])
};

export { Prose as default };
